import { WSMutationConfig } from "@ws-react-query";
import { IRateCard } from "@wingspanhq/payments/dist/interfaces";
import { IRateCardUpdateRequest } from "@wingspanhq/payments/dist/interfaces/api";
import { updateRateCard } from "../../../services/rateCards/updateRateCard";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import {
  QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE,
  QUERY_RATE_CARD
} from "../keys";

type RateCardUpdateParams = {
  rateCardId: string;
  update: IRateCardUpdateRequest;
  keysToDelete?: string[];
  payeeId?: string;
  payeeEngagementId?: string;
};

export const useUpdateRateCard = (
  config?: WSMutationConfig<IRateCard, WSServiceError>
) =>
  useWSMutation(
    ({ rateCardId, update, keysToDelete }: RateCardUpdateParams) =>
      updateRateCard(rateCardId, { update, keysToDelete }),
    {
      ...config,
      dependencies: [
        QUERY_RATE_CARD,
        QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE
      ],
      awaitDependencies(result, { rateCardId, payeeId, payeeEngagementId }) {
        const keysToInvalidate: any[] = [[QUERY_RATE_CARD, rateCardId]];

        if (payeeId && payeeEngagementId) {
          keysToInvalidate.push([
            QUERY_PAYEE_ENGAGEMENT_RATE_CARD_BY_PAYEE,
            payeeId,
            payeeEngagementId
          ]);
        }

        return keysToInvalidate;
      }
    }
  );
